import React, { useEffect, useState } from "react";
import HeaderRelatorio from "../HeaderRelatorio";
import InputDateForm from "../../../components/Input/InputDateForm";
import { TextFieldSearch } from "../../../components/TextField";
import { CircularProgress, Grid, withStyles } from "@material-ui/core";
import {
  findAllRelatorioEncaminhamentos,
  findAllRelatorioEncaminhamentosPdf,
  relatorioEncaminhamentosCsv,
} from "../../../services/RelatorioService";
import { inject } from "mobx-react";
import moment from "moment";
import Notification from "../../../components/Notification";
import PrintIcon from "../../../components/Icon/Print";
import { Button } from "../../../components/ui/Buttons";
import ArrowDownloadIcon from "../../../components/Icon/ArrowDownload";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import Table from "../../../components/Table/Table";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import { columns } from "./Constants";
import { observer } from "mobx-react-lite";
import ImpressaoHtml from "../../../components/Impressao/ImpressaoHtml";
import RelatorioEncaminhamentosImpressao from "./RelatorioEncaminhamentosImpressao";
import { findAllProfissionalSaude } from "../../../services/ProfissionalSaudeService";
import { base64Convert } from "../../../utils/base64ToCsv";
import { findAllEncaminhamentosRelatorio } from "../../../services/EncaminhamentoService";

export const pageableDTODefault = {
  pageNumber: 0,
  pageSize: 30,
  sortField: "nome",
  sortDir: "ASC",
};

const primeiroDiaMesAtual = moment()
  .startOf("month")
  .format("YYYY-MM-DD");
const ultimoDiaMesAtual = moment()
  .endOf("month")
  .format("YYYY-MM-DD");

export const filtersRelatorioPeriodoDefault = {
  profissionalSaude: null,
  procedimento: null,
  dataFim: ultimoDiaMesAtual,
  dataInicio: primeiroDiaMesAtual,
  encaminhamento: null,
};

const RelatorioEncaminhamentos = observer(({ classes, relatorioStore }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageableDTO, setPageableDTO] = useState(pageableDTODefault);
  const [filters, setFilters] = useState(filtersRelatorioPeriodoDefault);
  const [last, setLast] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [isPrintMustache, setIsPrintMustache] = useState(false);
  const [encaminhamentos, setEncaminhamentos] = useState([]);
  const [encaminhamentosPrint, setEncaminhamentosPrint] = useState(null);
  const [search, setSearch] = useState("");
  const [notification, setNotification] = useState({
    isOpen: false,
    message: "",
    variant: "",
  });

  useEffect(() => {
    findAllEncaminhamentosRealizados({ resetValues: true });
  }, []);

  const findAllEncaminhamentosRealizados = async (resetValues) => {
    try {
      setIsLoading(true);
      const { profissionalSaude, dataFim, dataInicio, encaminhamento } = filters;

      if (!dataInicio || !dataFim) {
        return showAlertMessage({
          isOpen: true,
          message: "Informe a data inicial e final!",
          variant: "error",
        });
      }

      const variables = {
        pageableDto: {
          ...pageableDTO,
          pageNumber: resetValues ? 0 : pageableDTO.pageNumber + 1,
        },
        search,
        ...(profissionalSaude?.id && {
          profissionalSaudeId: profissionalSaude?.id,
        }),
        ...(encaminhamento?.id && {
          encaminhamentoModeloId: encaminhamento?.id,
        }),
        ...(dataInicio && {
          dataInicio: moment(dataInicio).format("YYYY-MM-DDTHH:mm:ss"),
        }),
        ...(dataFim && {
          dataFim: moment(dataFim).format("YYYY-MM-DDTHH:mm:ss"),
        }),
      };

      const {
        content,
        last,
        totalElements,
      } = await findAllRelatorioEncaminhamentos(variables);
      setTotalElements(totalElements);
      setEncaminhamentos(content);
      setLast(last);
      const page = !resetValues && !last ? pageableDTO.pageNumber + 1 : 0;
      setPageableDTO({ ...pageableDTO, pageNumber: page });
    } catch (error) {
      showAlertMessage({
        message: "Erro ao buscar encaminhamentos!",
        variant: "error",
        isOpen: true,
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
    try {
      const { mostrarApenasProfissionaisAtivo } =
        relatorioStore.configuracaoUnidade || {};
      const { content, last } = (
        await findAllProfissionalSaude({
          pageNumber: page,
          search,
          ...(mostrarApenasProfissionaisAtivo && {ativo: mostrarApenasProfissionaisAtivo}),
        })
      ).data.data.findAllProfissionalSaude;
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      showAlertMessage({
        message: "Erro ao buscar profissionais!",
        variant: "error",
        isOpen: true,
      });
      console.error(error);
    }
  };

  const loadEncaminhamento = async (search, loadedOptions, { page }) => {
    try {
      const response = await findAllEncaminhamentosRelatorio({
        pageableDTO: {
          pageNumber: page,
          pageSize: 10,
          sortDir: "ASC",
          sortField: "nome",
        },
        search,
        ativo: true,
      });

      const { content, last } = response;

      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      showAlertMessage({
        message: "Erro ao buscar os modelos de encaminhamentos!",
        variant: "error",
        isOpen: true,
      });
      console.log(error);
    }
  };

  const handleFilters = (value, field) => {
    setFilters({ ...filters, [field]: value });
  };

  const showAlertMessage = (notification) => {
    setNotification(notification);

    const timeoutId = setTimeout(() => {
      closeAlertMessage();
      clearTimeout(timeoutId);
    }, 3000);
  };

  const closeAlertMessage = () => {
    const notification = {
      isOpen: false,
      message: "",
    };
    setNotification(notification);
  };

  const handlePrint = async () => {
    const { dataInicio, dataFim, profissionalSaude, encaminhamento } = filters;
    
    if (!dataInicio || !dataFim) {
      return showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Informe a data inicial e final!",
      });
    }
    try {
      const variables = {
        pageableDto: {
          sortDir: pageableDTO.sortDir,
          sortField: pageableDTO.sortField,
        },
        ...(profissionalSaude?.id && {
          profissionalSaudeId: profissionalSaude?.id,
        }),
        ...(encaminhamento?.id && {
          encaminhamentoModeloId: encaminhamento?.id,
        }),
        dataInicio: moment(dataInicio).format("YYYY-MM-DDTHH:mm:ss"),
        dataFim: moment(dataFim).format("YYYY-MM-DDTHH:mm:ss"),
      };

      const response = await findAllRelatorioEncaminhamentosPdf(variables);

      setEncaminhamentosPrint(response);
      setIsPrintMustache(true);
    } catch (e) {
      showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Erro ao gerar relatório!",
      });
    }
  };

  const handleDownload = (base64) => {
    const blob = base64Convert(base64);
    const url = window.URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = "Encaminhamentos.csv";
    document.body.appendChild(link);
    link.click();
  };

  const handleDownloadCSV = async () => {
    try {
      const { dataInicio, dataFim, profissionalSaude, encaminhamento } = filters;

      if (!dataInicio || !dataFim) {
      return showAlertMessage({
        isOpen: true,
        variant: "error",
        message: "Informe a data inicial e final!",
      });
    }

      const variables = {
        pageableDto: {
          ...pageableDTO,
          pageSize: 30,
          pageNumber: 0,
        },
        search,
        ...(profissionalSaude?.id && {
          profissionalSaudeId: profissionalSaude?.id,
        }),
        ...(encaminhamento?.id && {
          encaminhamentoModeloId: encaminhamento?.id,
        }),
        dataInicio: moment(dataInicio).format("YYYY-MM-DDTHH:mm:ss"),
        dataFim: moment(dataFim).format("YYYY-MM-DDTHH:mm:ss"),
      };

      const response = await relatorioEncaminhamentosCsv(variables);
      handleDownload(response);
    } catch (error) {
      showAlertMessage({
        isOpen: true,
        message: "Erro ao gerar Csv!",
        variant: "error",
      });
      console.error(error);
    }
  };

  const handleClickSearch = () => {
    findAllEncaminhamentosRealizados({ resetValues: true });
  };

  const onChangeSearch = (e) => {
    const event = e?.target?.value ?? e;
    setSearch(event);
  };

  return (
    <div>
      <HeaderRelatorio
        idPrefix="rel-enc"
        title="Encaminhamentos"
        hiddenFilter
        hiddenButtons
        totalTitle={"encaminhamentos"}
        totalAgendamentos={totalElements}
        search={() => handleClickSearch()}
        value={search}
        onChange={(e) => onChangeSearch(e)}
        clearSearch={() => onChangeSearch("")}
      />
      <div className={classes.filtros}>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}> Data início: </span>
          <InputDateForm
            id="rel-enc-inp-ini"
            iconposition="end"
            openTo="day"
            views={["year", "month"]}
            value={filters.dataInicio || ""}
            onChange={(e) => handleFilters(e, "dataInicio")}
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}> Data Fim: </span>
          <InputDateForm
            id="rel-enc-inp-fim"
            iconposition="end"
            openTo="day"
            views={["year", "month"]}
            value={filters.dataFim || ""}
            onChange={(e) => handleFilters(e, "dataFim")}
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}> Profissional: </span>
          <TextFieldSearch
            id="rel-enc-sel-prf"
            placeholder="Selecione"
            classNotched={classes.notchedOutline}
            loadOptions={loadProfissionaisSaude}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            value={filters.profissionalSaude}
            onChange={(e) => handleFilters(e, "profissionalSaude")}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            menuPosition="fixed"
          />
        </div>
        <div className={classes.campoFiltro}>
          <span className={classes.tituloFiltros}> Encaminhamento: </span>
          <TextFieldSearch
            id="rel-enc-sel-enc"
            placeholder="Selecione"
            classNotched={classes.notchedOutline}
            loadOptions={loadEncaminhamento}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            value={filters.encaminhamento}
            onChange={(e) => handleFilters(e, "encaminhamento")}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            menuPosition="fixed"
          />
        </div>
        <div>
          <Button
            id="rel-enc-btn-fil"
            bgColor={"#707C97"}
            onClick={() =>
              findAllEncaminhamentosRealizados({ resetValues: true })
            }
            disabled={!filters?.dataInicio || !filters.dataFim}
          >
            Filtrar
          </Button>
        </div>
      </div>
      <div className={classes.tableContainer}>
        <Scroll
          loadMore={findAllEncaminhamentosRealizados}
          hasMore={!last}
          pageStart={0}
          initialLoad={false}
        >
          <Table dados={encaminhamentos} columns={columns} />
          {encaminhamentos?.length === 0 && !isLoading && (
            <MensagemListaVazia />
          )}
          {isLoading && (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                marginTop: 20,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={30} />
            </Grid>
          )}
        </Scroll>

        <div className={classes.buttonsDownloadPrint}>
          <Button
            id="rel-enc-btn-imp"
            shape="circle"
            bgColor="#F9BE73"
            onClick={handlePrint}
            disabled={!filters?.dataInicio || !filters.dataFim}
          >
            <PrintIcon />
          </Button>
          <Button
            id="rel-enc-btn-csv"
            shape="circle"
            bgColor="#F9BE73"
            onClick={handleDownloadCSV}
            disabled={!filters?.dataInicio || !filters.dataFim}
          >
            <ArrowDownloadIcon />
          </Button>
        </div>

        {isPrintMustache && (
          <ImpressaoHtml
            isPrintMustache={isPrintMustache}
            handlePrintMustache={() => setIsPrintMustache(false)}
            htmlStringComponent={
              <RelatorioEncaminhamentosImpressao
                dadosRelatorio={encaminhamentosPrint || []}
                filters={filters}
                totalElements={totalElements}
              />
            }
          />
        )}

        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.isOpen}
          variant={notification.variant}
          message={notification.message}
        />
      </div>
    </div>
  );
});

const styles = {
  filtros: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: "8px",
    padding: "13px 16px 8px 16px",
    boxShadow:
      "10px 10px 25px rgb(112 124 151 / 5%), 15px 15px 35px rgb(112 124 151 / 5%)",
    background: "#fff",
    marginTop: 1,
  },
  campoFiltro: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "160px",
  },
  tituloFiltros: {
    color: "#868686",
    fontSize: "12px !important",
  },
  notchedOutline: {
    border: "0",
  },
  tableContainer: {
    overflow: "auto",
    margin: "16px",
    borderRadius: "16px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    background: "#fff",
    height: "calc(100vh - 251px)",
  },
  buttonsDownloadPrint: {
    display: "flex",
    position: "absolute",
    right: "14px",
    bottom: "78px",
    width: "88px",
    gap: "8px",
  },
};

const stores = ["relatorioStore"];
const RelatorioEncaminhamentosWithStyles = withStyles(styles)(
  RelatorioEncaminhamentos
);
export default inject(...stores)(RelatorioEncaminhamentosWithStyles);
